import React from 'react';
import { MediaLibPicker, useMediaLibContext } from '../medialib';
import { expandProps, FormControlProps } from './FormControlProps';
import { MediaLibListMultiPicker } from '../medialib/MediaLibListMultiPicker';

export const MediafileEdit = (props: FormControlProps) => {
    const medialib = useMediaLibContext();
    const { row, value, field, onChange, schema, extraProps } = expandProps(props);
    
    return (
        <MediaLibPicker
            selectedUrl={value}
            selectFile={mf => onChange(row, { [field]: mf ? medialib.getFilepath(mf) : null })}
            closeOnSelect
            size="small"
            label={schema?.label || field}
            {...extraProps}
            />
    );
}

export const MediafileMultiEdit = (props: FormControlProps) => {
    const { row, value, field, onChange, schema, extraProps } = expandProps(props);
    
    return (
        <MediaLibListMultiPicker
            selectedUrls={value}
            selectFiles={(mfs,urls) => onChange(row, { [field]: urls || [] })}
            label={schema?.label || field}
            hint={schema?.hint}
            {...extraProps}
            />
    );
}
